import {MockupList} from 'argo-ui/src/components/mockup-list/mockup-list';
import * as React from 'react';

export const Loading = () => (
    <div style={{margin: 20}}>
        <MockupList />
    </div>
);
